<template>
  <artmisads-modal
    :open="true"
    title="Payment Details"
    :width="1200"
    :onCancel="() => props.setShowPaymentDetailModal(false)"
    :destroyOnClose="true"
    :footer="null"
  >
    <a-spin :spinning="spinning">
      <div class="payment">
        <div class="detail">
          <p>Details</p>
          
          <div class="table">
            <artmisads-table
              :columns="columns"
              row-key="id"
              :data-source="list"
              :pagination="{
                total: listTotal,
                current: params.page,
                pageSize: params.size,
                showSizeChanger: true
              }"
             
              :change="onChangePage"
              tableLayout="fixed"
            >
              <template #bodyCell="{ column, record, text }">
                <template v-if="column.name === 'showCurrency'">
                  {{AMAZON_CURRENCY_MAPPER[record.marketplace]}}{{text}}
                </template>
                <template v-if="column.key === 'billingDate'">
                  {{ record.billingDate  }}
                </template>
                <template v-if="column.key === 'adjustmentValue'">
                  <span :class="text? text > 0 ? 'amount-plus' : 'amount-minus':''">
                     {{ setUnit(record.adjustmentValue) }}{{(text||text==0)&&record.adjustmentType==='FIXED_AMOUNT'? AMAZON_CURRENCY_MAPPER[record.marketplace] :''}}{{ setAmount(text) }}{{  (text||text==0)&&record.adjustmentType==='FIXED_AMOUNT'? '' : '%'}}
                  </span>
                  <!-- {{ record.adjustmentValue && record.adjustmentValue.toFixed(2) }} -->
                </template>
              </template>
            </artmisads-table>
          </div>
        </div>
      </div>
    </a-spin>
  </artmisads-modal>
</template>
<!-- FIXED_AMOUNT
PERCENTAGE -->
<script setup>
import moment from 'moment';
import { AMAZON_CURRENCY_MAPPER, AMAZON_COUNTRY_TIME_TZ } from '~/contants/common';
import { ref, onBeforeMount, computed, onMounted, watch } from "vue";
import { financeApi } from "~/server/operator/finance";



const props = defineProps([ 'setShowPaymentDetailModal', 'billingId']);
const list = ref([]);
const listTotal = ref(0);
const spinning = ref(false);

const params = ref({
  page: 1,
  size: 10,
  keyword: null,
});

const columns = [
    {
      title: 'Date',
      dataIndex: 'billingDate',
      key: 'billingDate',
      align: 'center'
    },
    {
      title: 'Adjustment Value',
      dataIndex: 'adjustmentValue',
      key: 'adjustmentValue',
      align: 'center'
    },
    {
      title: 'Comment',
      dataIndex: 'adjustmentReason',
      key: 'adjustmentReason',
      align: 'center'
    },
    
  ]

const onChangePage = (data, filters) => {
  const { current, pageSize } = data;
  params.value.page = current;
  params.value.size = pageSize;
  getFinanceSellerBillingsDetailsBillingIdItems();
}
  const setUnit = (record) => {
  if(record||record==0){
    if (record > 0) {
    return '+'
  }
  else if(record == 0){
    return ''
  }
  else {
    return '-'
  }
  }
  else{
    return ''
  }
}
const setAmount = (record) => {
  if(record||record==0){
  return Math.abs(record)
  }
  else{
    return '--'
  }
}
const getFinanceSellerBillingsDetailsBillingIdItems = async () => {
  spinning.value = true;
  const paramsData = {  billingId: props.billingId };
  const res = await financeApi.getFinanceSellerBillingsManualDetails(paramsData);
  const { data, total } = res;
  if (res) {
    listTotal.value = total;
    list.value = data;
  }
  spinning.value = false;
};




onBeforeMount(() => {
  getFinanceSellerBillingsDetailsBillingIdItems();
});
</script>

<style lang="less" scoped>
.amount-plus{
  color: #FF0000;
}
.amount-minus{
  color: #2AAE67;
}
.payment {
  .info {
    margin-top: 6px;
    .head {
      display: flex;
      justify-content: space-between;
      > p {
        font-weight: 600;
        font-size: 20px;
        color: var(--dark-1);
        letter-spacing: 0.5px;
        line-height: 28px;
      }
    }
  }
 
  .detail {
    > p {
      font-weight: 600;
      font-size: 20px;
      color: var(--dark-1);
      letter-spacing: 0.5px;
      line-height: 28px;
      margin-top: 16px;
      margin-bottom: 16px;
    }
    .filter {
      display: flex;
      justify-content: space-between;
      .search {
        display: flex;
        > button {
          display: flex;
          margin-right: 16px;
          .daochu {
            width: 20px;
            height: 20px;
            margin-right: 8px;
            fill: var(--dark-1);
          }
          > svg {
            align-self: center;
          }
          > span {
            align-self: center;
          }
        }
      }
    }
    .table {
      margin-top: 16px;
    }
  }
  
}
</style>
